import {
  Button,
  DynamicContent,
  IconRow,
  OneStop,
  SubmissionInfo,
} from 'components'

import {
  BsArrowRight,
  BsArrowRightSquare,
  BsArrowRightSquareFill,
  BsCheckSquare,
} from 'react-icons/bs'
import { BsCheckSquareFill } from 'react-icons/bs'

import { useTranslation } from 'react-i18next'
import useLocalStorageState from 'hooks/use-localstorage-state/use-localstorage-state'
import { SUBMISSIONS_NAME } from 'views/forms/form.constants'
import { Submission } from 'common.types'
import { useDynamicFormContent, useOneStop } from 'hooks'

const FIND_VOTING_LOCATION_URL = 'https://vote.pa'
const MAILIN_BALLOT_URL = 'https://vote.pa/mail/#0'
const VOTE_EARLY_URL = 'https://vote.pa/early'
const BALLOT_DROPBOX = 'https://vote.pa/return/'

export const VoterRegSuccessScreen = () => {
  const [submissions] = useLocalStorageState(
    SUBMISSIONS_NAME,
    {} as { [key: string]: any },
  )
  const FIND_POLLING_PLACE_URL = '/find/return'
  const { isOneStop, goToMailInBallot, goToPlanToVote } = useOneStop()
  const timestamps = Object.keys(submissions).map(Number)
  const mostRecentTimestamp = Math.max(...timestamps)
  const mostRecentValue: Submission =
    submissions[mostRecentTimestamp.toString()]
  const { serverResponse } = mostRecentValue.apiResponse
  const { applicationId, applicationDate, ovrMailinBallotApplicationId } =
    serverResponse?.data?.data?.response
  const { formState } = mostRecentValue
  const interest = formState.mailinBallotInterest
  const { t } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.successScreen`,
  })
  const { t: tMib } = useTranslation(undefined, {
    keyPrefix: `voterRegistrationForm.successScreenMib`,
  })
  const { formContent } = useDynamicFormContent()
  const dates = formContent?.dates
  const overrideContent =
    formContent?.formOverrides?.['voter-registration']?.success?.bottom
  const overrideVregMibContent =
    formContent?.formOverrides?.['voter-registration']?.success?.vRegNoMib
  const buttonWrapperStyle = { marginTop: 30, marginBottom: 40 }
  const mailInBallotDeadlineDate = formContent?.dates?.mailInBallotDeadline.date
    ? new Date(formContent?.dates?.mailInBallotDeadline.date)
    : undefined

  const mailinBallotDeadlinePassed =
    mailInBallotDeadlineDate &&
    new Date().getTime() > mailInBallotDeadlineDate.getTime()

  if (interest) {
    return (
      <div>
        <IconRow
          icon={BsCheckSquare}
          iconColor="green"
          text={tMib('success')}
        ></IconRow>
        <SubmissionInfo
          t={t}
          applicationDate={applicationDate}
          applicationId={applicationId}
          ovrMailinBallotApplicationId={ovrMailinBallotApplicationId}
          formState={formState}
        />
        <p
          style={{ marginLeft: 22, fontSize: 14 }}
          dangerouslySetInnerHTML={{ __html: t(`disclosureTwo`) }}
        ></p>
        <IconRow
          icon={BsArrowRightSquare}
          iconColor="blue"
          text={tMib('return')}
        ></IconRow>
        {overrideVregMibContent ? (
          <DynamicContent data={overrideVregMibContent} />
        ) : (
          <>
            <div style={buttonWrapperStyle}>
              <Button
                label={tMib('findABallotDropbox')}
                onClick={() => {
                  if (isOneStop) {
                    goToPlanToVote()
                  } else {
                    window.location.href = BALLOT_DROPBOX
                  }
                }}
                fullWidth={false}
              />
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: tMib('note1'),
              }}
            />
            <p
              dangerouslySetInnerHTML={{
                __html: tMib('note3', { electionDay: dates?.electionDay }),
              }}
            ></p>
            <p>{tMib('note4', { electionDay: dates?.electionDay })}</p>
          </>
        )}
      </div>
    )
  }
  return (
    <div>
      <IconRow
        icon={BsCheckSquare}
        iconColor="green"
        text={t('success')}
      ></IconRow>
      <SubmissionInfo
        t={t}
        applicationDate={applicationDate}
        applicationId={applicationId}
        formState={formState}
      />
      <p
        style={{ marginLeft: 22, fontSize: 14 }}
        dangerouslySetInnerHTML={{ __html: t(`disclosureTwo`) }}
      ></p>
      <p>{t(`bottomNote`)}</p>
      <IconRow
        icon={BsArrowRightSquare}
        iconColor="blue"
        text={t('plan')}
      ></IconRow>
      {overrideContent ? (
        <DynamicContent data={overrideContent} />
      ) : (
        <>
          {!mailinBallotDeadlinePassed && (
            <>
              {' '}
              <div style={buttonWrapperStyle}>
                <Button
                  label={t('requestMailinBallotButton')}
                  onClick={() => {
                    if (isOneStop) {
                      goToMailInBallot()
                    } else {
                      window.location.href = MAILIN_BALLOT_URL
                    }
                  }}
                  fullWidth={false}
                />
              </div>
            </>
          )}
          <div style={buttonWrapperStyle}>
            <Button
              label={t('findAVotingLocation')}
              onClick={() => {
                if (isOneStop) {
                  goToPlanToVote()
                } else {
                  window.location.href = mailinBallotDeadlinePassed
                    ? '/find/polls'
                    : '/find/return'
                }
              }}
              fullWidth={false}
            />
          </div>
        </>
      )}
    </div>
  )
}
